import type { ComboboxOption } from '@opendoor/atoms/combobox';

import { ApolloErrorLike } from '../apolloError';

export function formatPhoneNumberInput(phoneNumberInput: string): string {
  if (!phoneNumberInput) {
    return '';
  }
  const cleansedPhoneNumber = cleansePhoneNumber(phoneNumberInput);
  const p1 = cleansedPhoneNumber.substring(0, 3);
  const p2 = cleansedPhoneNumber.substring(3, 6);
  const p3 = cleansedPhoneNumber.substring(6, 10);

  const fragments = [
    p1.length > 0 ? '(' : '',
    p1,
    p2.length > 0 ? ') ' : '',
    p2,
    p3.length > 0 ? '-' : '',
    p3,
  ];

  return fragments.join('');
}

function cleansePhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }
  let cleansedPhoneNumber = phoneNumber.replace(/\D/g, '');
  // real phone numbers never have area codes starting with 1, but our fake numbers on staging do
  if (cleansedPhoneNumber[0] === '1' && cleansedPhoneNumber.length > 10) {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(1, 11);
  } else {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(0, 10);
  }
  return cleansedPhoneNumber;
}

export const sortRegionsByDisplayName = (a: ComboboxOption, b: ComboboxOption): number => {
  if (a.label < b.label) {
    return -1;
  }
  return 1;
};

export const getErrorMessage = (error: ApolloErrorLike) => {
  return error.message.replace('GraphQL error:', ' ').trim();
};
